import { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";

type SpinnerProps = ComponentProps<'div'>

export function Spinner(props: SpinnerProps) {
    return (
        <div className={twMerge
            ("inline-block size-8 animate-spin rounded-full border-4 border-solid border-current border-e-transparent align-[-0.125em] text-surface motion-reduce:animate-[spin_1.5s_linear_infinite] text-dark_primary dark:text-light_primary",
                props.className)}
            role="status">
            <span
                className="absolute! -m-px! h-px! w-px! overflow-hidden! whitespace-nowrap! border-0! p-0! [clip:rect(0,0,0,0)]!"
            >Carregando...
            </span>
        </div>
    )
}